var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F25022",
    d: "M30.905 30.904H246.553V246.554H30.905z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7FBA00",
    d: "M265.446 30.904H481.09400000000005V246.554H265.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A4EF",
    d: "M30.905 265.444H246.553V481.095H30.905z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB900",
    d: "M265.446 265.444H481.09400000000005V481.095H265.446z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMs);
export default __webpack_public_path__ + "static/media/icon-ms.b2f9bd058a49aca68da52a780c36045c.svg";
export { ForwardRef as ReactComponent };